import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import PhoenixFormsV4Control from "./PhoenixFormsV4Control";
import PhoenixFormsV4ReadOnlyControl from "./PhoenixFormsV4ReadOnlyControl";
import PNXLabel from "./PNXLabel";


interface Props {
  controlProps: controls.ContainerControl;
};

const PhoenixGroup = ({
  controlProps,
} : Props) => {

  return <div>
    <PNXLabel helpTopicId={controlProps.topicId} className="group-label">{controlProps.label}</PNXLabel>
    <div>
      {controlProps.controls.map(item => <PhoenixFormsV4Control key={`groupchild-${item.id}`} controlProps={item} parentControlProps={controlProps} />)}
    </div>
  </div>;
};

export const PhoenixGroupReadOnly = ({
  controlProps,
} : Props) => {

  return <div>
    <PNXLabel className="group-label">{controlProps.label}</PNXLabel>
    <div>
      {controlProps.controls.map(item => <PhoenixFormsV4ReadOnlyControl key={`groupchild-${item.id}`} controlProps={item} parentControlProps={controlProps} />)}
    </div>
  </div>;
};

export default PhoenixGroup;